module.exports = __webpack_public_path__ + "static/og-cd8c7fe539f9561227a535ab57ae9d28.png";